import { render, staticRenderFns } from "./ClinicResultHeader.vue?vue&type=template&id=4d6ea926&"
import script from "./ClinicResultHeader.vue?vue&type=script&lang=js&"
export * from "./ClinicResultHeader.vue?vue&type=script&lang=js&"
import style0 from "./ClinicResultHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports